"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeCost = computeCost;
const big_js_1 = __importDefault(require("big.js"));
function computeCost(vATRate, receivedCostWithoutVAT, receivedCostWithVAT) {
    let withVAT;
    let withoutVAT;
    const vatRateInBase100 = (0, big_js_1.default)(vATRate).times(100).toString();
    if (!receivedCostWithVAT && !receivedCostWithoutVAT) {
        return {
            vAT: '0',
            withoutVAT: '0',
            vATRate: vatRateInBase100,
            withVAT: '0'
        };
    }
    if (receivedCostWithVAT) {
        withVAT = receivedCostWithVAT;
        withoutVAT = (0, big_js_1.default)(withVAT).div((0, big_js_1.default)(vATRate).plus(1)).toString();
    }
    else {
        withoutVAT = receivedCostWithoutVAT;
        withVAT = (0, big_js_1.default)(withoutVAT).times((0, big_js_1.default)(vATRate).plus(1)).toString();
    }
    return { vAT: (0, big_js_1.default)(withVAT).minus(withoutVAT).toString(), vATRate: vatRateInBase100, withVAT, withoutVAT };
}
